import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../useAuth";
import API from "@/config/api";
import type { Brand } from "@/types/brand";

interface MyBrandsResponse {
  message: string;
  brands: Brand[];
}

async function fetchBrandsByUser() {
  const res = await API.main.get<MyBrandsResponse>(`/brands/user`);
  return res.data.brands??[];
}
export default function useUserBrands() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["brand", user?.id],
    queryFn: fetchBrandsByUser,
  });
}
